<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-log-list" class="ag-grid-container">
    <card-page>
      <grid-panel
          height="xl"
          :column-defs="columnDefs"
          :data="data"
          :search-query="searchQuery"
          @rowClicked="onRowClicked"
          title="Audit logs"
          :showSearch="false"
      >

        <template v-slot:top-right>
          <vue-form-generator
            ref="form"
            :model="model"
            :options="formOptions"
            :schema="schema"
          />
        </template>
      </grid-panel>
    </card-page>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { datepickerOptions } from '@/components/form/FormElementOption';
import { debounce } from 'lodash';
import moment from 'moment';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import CardPage from '../../components/Views/CardPage';

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import GridActionBar from "@/views/components/extra-components/GridActionBar";

export default {
  components: {
    TGrid,
    GridActionBar,
    GridPanel,
    CardPage,
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      currentPage: 1,
      searchParams: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      model: {
        searchString: '',
        fromDate: moment().subtract(10, 'days').format('YYYY-MM-DD'),
        toDate: null,
      },
      schema: {
        groups: [
          {
            styleClasses: 'flex justify-end',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'pb-0 mb-0 w-1/3',
                label: 'Search',
                model: 'searchString',
                validator: 'string',
              },
              {
                ...datepickerOptions,
                disabled: () => this.readonly,
                styleClasses: 'pb-0 mb-0 ml-2 w-1/6',
                label: 'From',
                model: 'fromDate',
                validator: 'string',
                onChanged: (model, schema, event, instance) => {
                  if (!schema) {
                    this.model.fromDate = null;
                  }
                },
              },
              {
                ...datepickerOptions,
                disabled: () => this.readonly,
                styleClasses: 'pb-0 mb-0 ml-2 w-1/6',
                label: 'To',
                model: 'toDate',
                validator: 'string',
                onChanged: (model, schema, event, instance) => {
                  if (!schema) {
                    this.model.toDate = null;
                  }
                },
              },
            ]
          },
        ],
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 120,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'User',
          field: 'user',
          filter: 'agTextColumnFilter',
          minWidth: 300,
          valueGetter: ({ data }) => {
            if (!data.FirstName) {
              return '';
            }

            let name = data.FirstName;

            if (data.LastName) {
              name += ` ${data.LastName}`;
            }

            return name;
          }
        },
        {
          headerName: 'Event',
          field: 'Event',
          minWidth: 300,
        },
        {
          headerName: 'Entity',
          field: 'Auditable_Type',
          filter: 'agTextColumnFilter',
          minWidth: 300,
        },
        {
          headerName: 'IP Address',
          field: 'Ip_Address',
          filter: 'agTextColumnFilter',
          minWidth: 300,
        },
        {
          headerName: 'Date',
          field: 'CreatedDate',
          filter: 'agTextColumnFilter',
          minWidth: 300,
        },

      ],
      // Cell Renderer Components
      data: [],
      loading: false,
      limit: 5000,
      totalPages: 1,
    }
  },
  watch: {
    currentPage: {
      handler(newValue) {
        this.filteredSearch({
          searchFilters: this.model,
          page: newValue,
          limit: this.limit
        })
      },
      immediate: true,
    },
    model: {
      handler(value) {
        this.filteredSearch(value)
      },
      deep: true,
    },
  },
  methods: {
    async onRowClicked({data}) {
      const route = 'audit.view';

      if (await this.canAccessRoute(route, false)) {
        this.$router.push({ name: route, params: { id: data.id }}).catch(() => {});
      }
    },
    filteredSearch(searchFilters, currentPage, limit) {
      const filters = searchFilters || this.model

      if (filters.toDate) {
        filters.toDate = moment(filters.toDate).format('YYYY-MM-DD')
      }

      if (filters.fromDate) {
        filters.fromDate = moment(filters.fromDate).format('YYYY-MM-DD')
      }

      this.list({
        page: currentPage || this.currentPage,
        limit: limit || this.limit,
        searchFilters: filters,
      });
    },
    list: debounce( async function(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.audits.list({ params });
        this.data = data.data;
        this.totalPages = Math.round((data.meta.total / this.limit)) + 1;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }, 250),
  },
}

</script>

<style lang="scss">
</style>
